import React from 'react';
import { connect } from 'react-redux';
import { scoreSelector, resetState } from '../services/store';

import Box from '../components/Box';
import Chapter from '../components/Chapter';
import Text from '../components/Text';
import Donut from '../components/Donut';
import Button from '../components/Button';

const Results = ({
  id,
  trackEvent,
  score,
  resetState,
}) => (
  <Chapter
    id={id}
    title="Eindscore"
    onEnter={() => trackEvent(id, null, score)}
  >
    <Donut value={score} />

    {score <= 500 && (
      <Text>Jouw score is erg laag. Dit kan serieuze gevolgen hebben. Je riskeert een plek op de zwarte lijst. Het kan je baankansen en studiekansen verpesten. En het kan je je vrienden kosten.</Text>
    )}

    {score > 500 && score <= 590 && (
      <Text>Jouw score is lager dan het gemiddelde. De meeste mensen om je heen hebben een hogere score. Het wordt een risico om met je om te gaan, want dat kan ze punten kosten. Die score moet snel omhoog.</Text>
    )}

    {score > 590 && score <= 680 && (
      <Text>Jouw score is gemiddeld. Je kunt genieten van snel internet, de apps van Alibaba gebruiken. Je hoeft geen borg te betalen of in lange rijen te staan. En de overheid laat jou je gang gaan.</Text>
    )}

    {score > 680 && (
      <Text>Jouw score is hoog. Zet dit door en je maakt kans op allerlei privileges in het leven. Nu al kun je gebruik maken van luxe hotels en restaurants, kun je businessclass tickets kopen. En je kunt een plek in de politiek bemachtigen, mocht je dat willen.</Text>
    )}
    <Box center>
      <Text>Benieuwd wat de uitslag is als je andere keuzes had gemaakt?</Text>
      <Button onClick={() => {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        resetState();
      }}>
        Opnieuw
      </Button>
    </Box>

    <Text>Dit verhaal is een samenwerking met Nieuwsuur. Check hun reportage <a href="https://nos.nl/nieuwsuur" rel="noopener noreferrer" target="_blank">hier</a>.</Text>
  </Chapter>
);

export default connect(scoreSelector, { resetState })(Results);



// WEBPACK FOOTER //
// ./src/chapters/Results.js